import React from 'react'

import InfoIcon from '../../../assets/icons/info.svg?react'

type Props = { text: string, iconColor?: string }
const InfoText: React.FC<Props> = ({ text, iconColor = 'dark-green' }) => {
  return (
    <div className='inline-flex gap-x-1'>
      <InfoIcon className={`w-10 h-6 stroke-${iconColor}`} />
      <div className='text-2xs sm:text-xs pl-3 text-left'>
        {text}
      </div>
    </div>
  )
}

export default InfoText
